module.exports = __webpack_public_path__ + "static/media/ระกา.bba4af8e.jpg";